"use client"
import { ITrack } from '@models'
import React from 'react'
import styles from './playlist.module.scss'
import Icon from '@components/icon'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import { OPEN_SPOTIFY } from '@lib/helpers'

export default function PlaylistMobile({tracks}: {tracks: ITrack[]}) {
    return (
        <div className={`${styles.container} ${styles.mobile}`}>
            {
                tracks.map((track, index) => (
                    <div key={track.id} className={styles.track}>
                        {
                            track.image && <Image loading='lazy' src={track.image} width={50} height={50} alt={track.name} />
                        }
                        <div className={styles.width}>
                            <span>{track.name}</span>
                            <div className={styles.artists}>
                                {
                                    track.artists.map((artist, index) => (
                                        <span key={index}>{artist}</span>
                                    ))
                                }
                            </div>
                        </div>
                        <div className={`${styles.go} click`} onClick={() => OPEN_SPOTIFY(track.href)}>
                            <Icon icon={faPlayCircle} />
                            האזנה ב-Spotify
                        </div>
                    </div>
                ))
            }
        </div>
    )
}